import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import React from 'react';

import zparse from 'utils/zparse';

import Pin from './pin';

const NeighborhoodCard = ({ title, body, image, href, isActive, useLargeBody }) => {
	const [shouldPinHover, setShouldPinHover] = React.useState(false);

	return (
		<Card
			className={`neighborhoodsMap__card${isActive ? ' neighborhoodsMap__card--active' : ''}${image ? ' neighborhoodsMap__card--withImage' : ' neighborhoodsMap__card--noImage'}`}
			sx={{
				background: image ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.20) 100%), url('${image}?max-w=720&quality=60') lightgray 50% / cover no-repeat` : 'none',
				'&:hover .MuiCardActionArea-focusHighlight': {
					backgroundColor: 'transparent',
					opacity: 0,
				},
			}}
			onMouseEnter={() => setShouldPinHover(true)}
			onMouseLeave={() => setShouldPinHover(false)}
		>
			<CardActionArea
				sx={{
					'&:hover .MuiCardActionArea-focusHighlight': {
						backgroundColor: 'transparent',
						opacity: 0,
					},
				}}
				href={href || undefined}
				target={(href && /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(href)) ? '_blank' : undefined}
			>
				<CardContent className="neighborhoodsMap__cardContent">
					<Pin ghost isHover={shouldPinHover} isActive={isActive || shouldPinHover} />
					{body && (
						<Typography variant="body2" className={`neighborhoodsMap__cardBody${useLargeBody ? ' neighborhoodsMap__cardBody--large' : ''}`}>
							{zparse(body)}
						</Typography>
					)}
					<Typography variant="h4" component="div" className="neighborhoodsMap__cardTitle">
						{title}
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default NeighborhoodCard;
